import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form, Row, Col, Spinner, Card, Badge, Nav } from "react-bootstrap";
import useMediaQuery from "../../hooks/useMediaQuery";
import CustomCalendar from "../../components/CustomCalendar/CustomCalendar";
import moment from "moment";
import 'moment/locale/it';
import CustomModal from "../../components/CustomModal/CustomModal";
import ComebackArrow from "../../components/ComebackArrow/ComebackArrow";
import { alertService } from '../../services/AlertService';
import useEsami from "../../hooks/useEsami";
import useCorsiUtenti from "../../hooks/useCorsiUtenti";
import useEsamiUtenti from "../../hooks/useEsamiUtenti";
import EsamiUtentiService from '../../services/EsamiUtentiService/EsamiUtentiService';
import CustomButton from "../../components/CustomButton/CustomButton";
import useClassiUtenti from "../../hooks/useClassiUtenti";
import { TIPO_CORSO } from "../../model/tipoCorso";
import useAttestati from "../../hooks/useAttestati";
import SelectRecipientModal from '../../components/SelectRecipientModal/SelectRecipientModal';
import useUtenti from "../../hooks/useUtenti"; 
import InputUserinfo from "../../components/InputUserInfo/InputUserInfo";

const MODAL_TYPES = {
  NEW: 'NEW',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
  DELETE: 'DELETE',
  MANAGE_USERS: 'MANAGE_USERS'
};

export default function EsamiConfigPage() {
  
  const {
    modalStateUtenti,
    setModalStateUtenti
    // Potrebbe servire anche loadingStateUtenti.isLoadingUtentiUpdate se InputUserinfo lo usa
   } = useUtenti();
  
  const {
    getEsamiByIdClasse,
    createEsame,
    deleteEsame,
    updateEsame,
    loadingStateEsami,
  } = useEsami();

  const {
    downloadAttestato,
    loadingStateAttestati,
    modalStateAttestati,
    setModalStateAttestati,
    aggiornaSpedizioneAttestato,
    stampaBustaAttestato
   } = useAttestati();

  const {
    updateEsameUtente,
    loadingStateEsamiUtenti,
    enterJoinroomAdmin
  } = useEsamiUtenti();

  const [userForEnvelopePrint, setUserForEnvelopePrint] = useState(null);
  const [selectedSoggettoForPrint, setSelectedSoggettoForPrint] = useState('corsista');

  const { getClassiUtentiByIdClasse } = useClassiUtenti();

  const location = useLocation();
  const navigate = useNavigate();
  const classe = location.state?.classeData;
  const isWideScreen = useMediaQuery("(min-width: 1200px)");
  const [exams, setExams] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newExam, setNewExam] = useState({
    data: "",
    ora_inizio: "",
    ora_fine: "",
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingExamId, setEditingExamId] = useState(null);
  const [modalMode, setModalMode] = useState(MODAL_TYPES.NEW);

  const [corsoUtenti, setCorsoUtenti] = useState([]);
  const [selectedExamUsers, setSelectedExamUsers] = useState([]);
  const userPrenotato = newExam?.utenti?.find(u => u.prenotato);

  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [examCountdowns, setExamCountdowns] = useState({});
  const [selectedUtenteForEdit, setSelectedUtenteForEdit] = useState(null);

  const [creationType, setCreationType] = useState('single'); // 'single' o 'multiple'
  const [numeroPosti, setNumeroPosti] = useState(1);

useEffect(() => {
    // Controlla se 'classe' e 'classe.id_classe' sono validi prima di procedere
    if (!classe?.id_classe) {
      // Se mancano i dati della classe, naviga indietro
      console.warn("useEffect: Dati classe mancanti o incompleti. Navigazione..."); // Lasciamo un avviso
      if (classe?.corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA) {
        navigate("/gestione-corsi");
      } else {
        navigate("/gestione-classi");
      }
      return; // Interrompe l'esecuzione dell'effetto
    }

    // Se i dati della classe ci sono, chiama le funzioni per caricare i dati
    fetchExams();

    // Carica i corsisti solo se non è un corso asincrono
    if (classe?.corso?.modalita_erogazione !== TIPO_CORSO.TELEMATICA_ASINCRONA) {
      fetchCorsoUtenti();
    }

  // Esegui questo effetto solo quando l'oggetto 'classe' cambia
  }, [classe, navigate]); // Aggiungi navigate alle dipendenze per best practice


  const fetchExams = async () => {
    if (classe?.id_classe) {
      const obj = { id_classe: classe.id_classe };
      try {
        const fetchedExams = await getEsamiByIdClasse(obj); // Chiamata API

        // console.log("DEBUG fetchExams - Dati ricevuti da API:", JSON.stringify(fetchedExams, null, 2)); // LOG 1

        if (Array.isArray(fetchedExams)) {
          const formattedExamsForState = fetchedExams.map(examBE => {
            // Estrai il primo utente dall'array 'utenti' (contiene TUTTI i dati specifici)
            const utenteData = (examBE.utenti && examBE.utenti.length > 0) ? examBE.utenti[0] : null;

            // --- OGGETTO DA SALVARE NELLO STATO ---
            return {
              // Dati base dell'esame (da examBE)
              id_calendario_esame: examBE.id_calendario_esame,
              data: examBE.data?.split(' ')[0],
              ora_inizio: examBE.ora_inizio,
              ora_fine: examBE.ora_fine,

              is_multiplo: examBE.is_multiplo, // <--- NUOVO
              max_parts: examBE.max_parts,     // <--- NUOVO

              // === DATI EXTRA LETTI DA utenteData (se esiste) ===
              id_classe_utente: utenteData?.id_classe_utente,
              esito_esame: utenteData?.esito_esame,
              stato_pagamento: utenteData?.stato_pagamento,     // Leggi da utenteData
              pagamento_partner: utenteData?.pagamento_partner, // Leggi da utenteData
              id_attestato: utenteData?.id_attestato,
              soggetto_spedizione: utenteData?.soggetto_spedizione,
              // =================================================

              // Dati risorsa (utente) - Popolati da utenteData
              resource: utenteData ? {
                  id_utente: utenteData.id_utente,
                  nome: utenteData.nome,
                  cognome: utenteData.cognome,
                  id_agenzia: utenteData.id_agenzia,
                  // Aggiungi altri campi utente se presenti nell'API e necessari
                  luogo_nascita: utenteData.luogo_nascita,
                  data_nascita: utenteData.data_nascita,
                  path_documento: utenteData.path_documento, // Aggiunto per modale modifica
                  path_codicefiscale: utenteData.path_codicefiscale, // Aggiunto per modale modifica
                  path_documento_retro: utenteData.path_documento_retro, // Aggiunto
                  path_codicefiscale_retro: utenteData.path_codicefiscale_retro, // Aggiunto
                  provincia_nascita: utenteData.provincia_nascita, // Leggi da utenteData
                  telefono1: utenteData.telefono1,             // Leggi da utenteData
                  telefono2: utenteData.telefono2
              } : null,

              // Array 'utenti' originale (mantenuto per sicurezza/conteggi)
              utenti: examBE.utenti || []
            };
            // --- FINE OGGETTO DA SALVARE ---
          }); // Fine .map


          setExams(formattedExamsForState); // Aggiorna lo stato
        } else {
          console.warn("fetchExams: La risposta API non è un array", fetchedExams);
          setExams([]);
        }
      } catch (error) {
           console.error("ERRORE in fetchExams:", error);
           setExams([]);
      }
    } else {
         console.warn("fetchExams: Chiamata saltata, id_classe mancante?");
    }
  };
    const fetchCorsoUtenti = async () => {
      if (classe?.corso?.id_corso) {
        const fetchedCorsoUtenti = await getClassiUtentiByIdClasse({ id_classe: classe.id_classe });
        const corsisti = fetchedCorsoUtenti.filter(utente => utente.tipo_utente === 'corsista');
        setCorsoUtenti(corsisti);
      }
    };

    const minDate = classe?.data_fine ? moment(classe.data_fine, "YYYY-MM-DD HH:mm:ss").toDate() : new Date();

    useEffect(() => {
      moment.locale('it'); 
    }, []);

  const formatDate = (date) => {
    if (!date) return '';
    const momentDate = moment(date);
    return momentDate.format('dddd D MMMM YYYY').replace(/^\w/, (c) => c.toUpperCase());
  };

  const openEditUserModal = (utente) => {
    if (!utente) {
        console.error("openEditUserModal chiamata senza dati utente.");
        alertService.error("Dati utente non disponibili per la modifica.");
        return;
    }
    console.log("Apertura modale modifica per utente:", utente); // Debug
    setSelectedUtenteForEdit(utente); // Salva i dati dell'utente da modificare
    setModalStateUtenti((prev) => ({ ...prev, showModalUpdateUtente: true }));
    setShowModal(false); // Chiudi la modale dei dettagli esame (se aperta)
  };

  const getFontePagamentoText = (pagamentoPartnerValue) => {
        switch (parseInt(pagamentoPartnerValue, 10)) { // Usa parseInt per sicurezza
            case 1:
                return 'Corsista';
            case 2:
                return 'Partner';
            case 3:
                return 'Superpartner';
            case 0:
            default:
                return 'Non Assegnato'; // Mostra Non Assegnato per 0 o null/undefined
        }
    };

  // Funzione per CHIUDERE la modale di modifica utente
  const handleCloseEditUserModal = () => {
    setModalStateUtenti((prev) => ({ ...prev, showModalUpdateUtente: false }));
    setSelectedUtenteForEdit(null); // Pulisci lo stato
    // Opzionale: riapri la modale dettagli esame se era aperta prima
    // if (newExam) setShowModal(true);
  };

  const handleSelectSlot = (slotInfo) => {
    const data = moment(slotInfo.start).format("YYYY-MM-DD");
    const ora_inizio = moment(slotInfo.start).format("HH:mm");
    const ora_fine = moment(slotInfo.end).format("HH:mm");
    setNewExam({ data, ora_inizio, ora_fine });
    setIsEditMode(false);
    setEditingExamId(null);
    setModalMode(MODAL_TYPES.NEW);
    setShowModal(true);
  };

  /*
const handleSelectEvent = (event) => {
  
    // Verifica se i dati essenziali sono presenti (es. resource)
    // Adapta questa condizione se necessario in base a cosa vedi nel log sopra
    if (event.id_calendario_esame && event.resource) {
        setNewExam({
            // === LISTA ESPLICITA DI TUTTE LE PROPRIETÀ NECESSARIE ===

            // Dati base dell'esame
            id_calendario_esame: event.id_calendario_esame,
            data: moment(event.start).format("YYYY-MM-DD"), // Formattato
            ora_inizio: moment(event.start).format("HH:mm:ss"), // Formattato
            ora_fine: moment(event.end).format("HH:mm:ss"),   // Formattato

            // Dati del corsista (da resource)
            resource: event.resource, // Copia l'intero oggetto resource

            // Dati specifici dell'esame/utente (letti direttamente da event)
            esito_esame: event.esito_esame,
            id_attestato: event.id_attestato,
            id_classe_utente: event.id_classe_utente,
            soggetto_spedizione: event.soggetto_spedizione,

            // === Aggiunta esplicita dei campi di pagamento ===
            stato_pagamento: event.stato_pagamento,
            pagamento_partner: event.pagamento_partner,
            // ===============================================

            // Array utenti originale (se serve altrove)
            utenti: event.utenti || []
        });
        setModalMode(MODAL_TYPES.VIEW);
        setShowModal(true);
    } else {
        alertService.warn("Dati evento cliccato incompleti o non validi.");
        console.error("Errore: Oggetto event ricevuto al click non contiene dati attesi", event);
    }
  };
*/

const handleSelectEvent = (event) => {
  // Trova l’esame completo dallo stato (per sicurezza/futuri campi)
  const fullExam = exams.find(e => e.id_calendario_esame === event.id_calendario_esame);

  // Prepara i dati base sempre, anche se non c’è resource/corsista
  const payload = {
    id_calendario_esame: event.id_calendario_esame,
    data: moment(event.start).format("YYYY-MM-DD"),
    ora_inizio: moment(event.start).format("HH:mm:ss"),
    ora_fine: moment(event.end).format("HH:mm:ss"),

    // dati corsista (può essere null, ed è OK: la UI lo gestisce)
    resource: event.resource ?? fullExam?.resource ?? null,

    // campi specifici (ok se undefined)
    esito_esame: event.esito_esame ?? fullExam?.esito_esame,
    id_attestato: event.id_attestato ?? fullExam?.id_attestato,
    id_classe_utente: event.id_classe_utente ?? fullExam?.id_classe_utente,
    soggetto_spedizione: event.soggetto_spedizione ?? fullExam?.soggetto_spedizione,
    stato_pagamento: event.stato_pagamento ?? fullExam?.stato_pagamento,
    pagamento_partner: event.pagamento_partner ?? fullExam?.pagamento_partner,

    // mantieni l’array utenti (anche vuoto)
    utenti: Array.isArray(event.utenti) ? event.utenti : (fullExam?.utenti || []),
  };

  setNewExam(payload);
  setEditingExamId(event.id_calendario_esame); // IMPORTANTISSIMO per edit/delete
  setIsEditMode(true);                         // così handleSaveExam fa UPDATE
  setModalMode(MODAL_TYPES.VIEW);
  setShowModal(true);
};


  const handleCloseModal = () => {
    setShowModal(false);
    setNewExam({ data: "", ora_inizio: "", ora_fine: "" });
    setIsEditMode(false);
    setEditingExamId(null);
    setModalMode(MODAL_TYPES.NEW);
    setCreationType('single');
    setNumeroPosti(1);
  };

  const handleSaveExam = async () => {
    // Validazione orari
    if (newExam.ora_fine <= newExam.ora_inizio) {
      alertService.warn("L'ora di fine deve essere successiva all'ora di inizio", { autoClose: true });
      return;
    }

    // Prepariamo i flag in base alla selezione dell'utente
    const isMultiplo = creationType === 'multiple' ? 1 : 0;
    // Se è singolo, max_parts è 1 (o null, a tua scelta). Se multiplo, prende il valore dell'input.
    const maxParts = creationType === 'multiple' ? numeroPosti : 1;

    const baseExamData = {
      id_corso: classe?.corso.id_corso,
      id_classe: classe?.id_classe,
      data: newExam?.data,
      ora_inizio: newExam?.ora_inizio,
      ora_fine: newExam?.ora_fine,
      // --- NUOVI CAMPI DA INVIARE ---
      is_multiplo: isMultiplo,
      max_parts: maxParts
    };

    try {
      if (isEditMode) {
        // UPDATE
        const examData = { ...baseExamData, id_calendario_esame: editingExamId };
        // Nota: Assicurati che anche la update nel PHP gestisca is_multiplo/max_parts se vuoi permettere di modificarli
        const updatedExam = await updateEsame(examData);
        
        if (updatedExam === -1) {
          alertService.warn("Esiste già un esame previsto all'interno di questa fascia oraria.", { autoClose: true });
        } else {
          await fetchExams();
        }

      } else {
        // CREATE
        // Ora facciamo UNA sola chiamata, sia per singolo che per multiplo.
        // È il Database che gestirà la differenza grazie ai campi is_multiplo/max_parts.
        const createdExam = await createEsame(baseExamData);

        if (createdExam === -1) {
          // Questo errore ora scatta correttamente se c'è GIÀ un esame in quell'ora
          alertService.warn("Esiste già un esame previsto all'interno di questa fascia oraria.", { autoClose: true });
        } else {
          const msg = isMultiplo 
            ? `Sessione di gruppo (${maxParts} posti) creata con successo.` 
            : "Esame singolo creato con successo.";
          alertService.success(msg, { autoClose: true });
          
          await fetchExams();
        }
      }
    } catch (error) {
      console.error("Errore salvataggio esame", error);
      alertService.error("Errore imprevisto durante il salvataggio.");
    }

    handleCloseModal();
  };


  const handleEditClick = () => {
    setModalMode(MODAL_TYPES.EDIT);
  };

  const handleDeleteClick = () => {
    setModalMode(MODAL_TYPES.DELETE);
  };

  const handleDeleteExam = async () => {
    await deleteEsame({ id_esame: editingExamId });
    setExams(exams.filter(exam => exam.id_calendario_esame !== editingExamId));
    handleCloseModal();
  };

  const handleCancelDelete = () => {
    setModalMode(MODAL_TYPES.VIEW);
  };

  const handleManageUsers = async (exam) => {
    setNewExam(exam);
    setSelectedExamUsers(exam.utenti || []);
    setModalMode(MODAL_TYPES.MANAGE_USERS);
  };

  const handleUserSelection = (user) => {
    setSelectedExamUsers(prev => 
      prev.some(u => u.id_utente === user.id_utente)
        ? prev.filter(u => u.id_utente !== user.id_utente)
        : [...prev, user]
    );
  };

  const handleSaveUserSelection = async () => {
      const obj = {
        id_calendario_esame: newExam.id_calendario_esame,
        utenti: selectedExamUsers
      }
      await updateEsameUtente(obj);
      handleCloseModal();
      fetchExams();
  };

  const handleConfirmCancelUserBooking = async () => {
    if (!userPrenotato) return;
    try {
      await EsamiUtentiService.deleteEsameUtente({
        id_esame_utente: userPrenotato.id_calendario_esame_utente
      });
      alertService.success("Prenotazione annullata con successo.", { autoClose: true });
      setShowConfirmDeleteModal(false);
      handleCloseModal();
      fetchExams();
    } catch (error) {
      alertService.error('Errore durante l\'annullamento della prenotazione.');
    }
  };

  useEffect(() => {
    updateCountdowns(); // chiamata iniziale
    const interval = setInterval(updateCountdowns, 1000);
    return () => clearInterval(interval);
  }, [exams]);
  
  const updateCountdowns = () => {
    const now = moment();
    const updatedCountdowns = {};
  
    exams.forEach(exam => {
      const start = moment(`${exam.data}T${exam.ora_inizio}`);
      const diffSeconds = start.diff(now, 'seconds');
  
      if (diffSeconds <= 0) {
        updatedCountdowns[exam.id_calendario_esame] = 'INIZIATO';
      } else if (diffSeconds <= 86400) {
        if (diffSeconds < 60) {
          updatedCountdowns[exam.id_calendario_esame] = `Inizio tra ${diffSeconds} second${diffSeconds === 1 ? 'o' : 'i'}`;
        } else if (diffSeconds < 3600) {
          const minutes = Math.floor(diffSeconds / 60);
          updatedCountdowns[exam.id_calendario_esame] = `Inizio tra ${minutes} minut${minutes === 1 ? 'o' : 'i'}`;
        } else {
          const duration = moment.duration(start.diff(now));
          const hours = duration.hours();
          const minutes = duration.minutes();
          updatedCountdowns[exam.id_calendario_esame] = `Inizio tra ${hours} or${hours === 1 ? 'a' : 'e'} e ${minutes} minut${minutes === 1 ? 'o' : 'i'}`;
        }
      }
    });
  
    setExamCountdowns(prev => {
      const changed = Object.keys(updatedCountdowns).some(
        key => updatedCountdowns[key] !== prev[key]
      );
      return changed ? updatedCountdowns : prev;
    });
  };

  const enterJoinRoom = async (id_calendario_esame, exam) => {
      try {
        let response;
        var id_utente = exam.utenti[0].id_utente;//FISSO IN CASO DI UN UTENTE PER SINGOLA DATA ESAME
        console.log(exam.utenti[0].id_utente);
        response = await enterJoinroomAdmin({ id_calendario_esame: id_calendario_esame, id_user: id_utente });
        var meeting_id = response[0].meeting_id;
        var enc_str = response[0].enc_str;
        if(meeting_id.length > 0){
          handleJoinMeeting(meeting_id ,  enc_str);
        }
      } catch (error) {
        alertService.error('Errore durante l\'accesso alla Joinroom di esame.');
      }
    };
  
  const handleJoinMeeting = async (meeting_id ,  enc_str) => {
    // 1. Apri subito una nuova scheda vuota in risposta al click.
    // Safari lo permette perché è un'azione sincrona.
    const newWindow = window.open('', '_blank');
    // Puoi mostrare un messaggio di cortesia nella nuova scheda.
    newWindow.document.write('Caricamento della riunione in corso...');

    try {
       // 3. Costruisci l'URL finale.
      const meetingUrl = `https://www.jampink.com/jp-meeting/${meeting_id}?se=${enc_str}`;

      // 4. Reindirizza la scheda, che è già aperta, all'URL corretto.
      // Questo non viene bloccato perché stai solo cambiando l'URL di una scheda esistente.
      newWindow.location.href = meetingUrl;

    } catch (error) {
      console.error("Errore nel recupero dei dettagli della riunione:", error);
      // In caso di errore, puoi comunicarlo all'utente nella nuova scheda.
      newWindow.document.write('Impossibile caricare la riunione. Per favore, chiudi questa scheda e riprova.');
    }
  };

  // Funzioni per Modale Busta
    const openSelectRecipientModal = (userData) => {
        setUserForEnvelopePrint(userData);
        setModalStateAttestati(prev => ({ ...prev, showSelectRecipientModal: true }));
        setShowModal(false); // Chiudi modale dettaglio esame
    };
    const handleCloseSelectRecipientModal = () => {
        setModalStateAttestati(prev => ({ ...prev, showSelectRecipientModal: false }));
        setUserForEnvelopePrint(null);
        // Ri-apri la modale precedente? Opzionale.
        // if (newExam) setShowModal(true);
    };
    const handleSubjectChangeForPrint = (newSoggetto) => {
        setSelectedSoggettoForPrint(newSoggetto);
    };
    const handleConfirmRecipientAndPrint = async () => {
        if (!userForEnvelopePrint || !userForEnvelopePrint.id_attestato) return;
        const currentSelectedSoggetto = selectedSoggettoForPrint;
        const hasAgenzia = userForEnvelopePrint?.id_agenzia;
        if (currentSelectedSoggetto === 'agenzia' && !hasAgenzia) {
             alertService.warn("Il corsista non è associato a un'agenzia."); return;
         }
        const saveSuccess = await aggiornaSpedizioneAttestato({
            id_attestato: userForEnvelopePrint.id_attestato,
            soggetto_spedizione: currentSelectedSoggetto,
        });
        if (saveSuccess) {
            await stampaBustaAttestato({ id_attestato: userForEnvelopePrint.id_attestato });
            handleCloseSelectRecipientModal();
            fetchExams(); // Aggiorna dati esami
        }
    };
  
 /*  const handleUploadStatino = async (event, idCalendarioEsameUtente) => {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    const formData = new FormData();
    formData.append('statino', file);
    formData.append('id_calendario_esame_utente', 63);

    try {
      await EsamiUtentiService.uploadStatino(formData);
      alertService.success('Statino caricato con successo');
    } catch (error) {
      alertService.error('Errore nel caricamento dello statino: ' + error.message);
    }
  }; */

const renderModalBody = () => {
    // Funzione per aprire la modale busta (definita fuori)
    const openSelectRecipientModal = (userData) => {
        setUserForEnvelopePrint(userData);
        setModalStateAttestati(prev => ({ ...prev, showSelectRecipientModal: true }));
        setShowModal(false); // Chiudi la modale corrente
    };

    switch (modalMode) {
      case MODAL_TYPES.NEW: // Logica originale per NUOVO
            return (
                      <Form>
                        <Row className="mb-3">
                          <Col xs={6}>
                            <Form.Group>
                              <Form.Label><span className='text-muted'><b>Orario inizio</b></span></Form.Label>
                              <Form.Control
                                type="time"
                                value={newExam?.ora_inizio || ''}
                                onChange={(e) => setNewExam({ ...newExam, ora_inizio: e.target.value })}
                              />
                            </Form.Group>
                          </Col>
                          <Col xs={6}>
                            <Form.Group>
                              <Form.Label><span className='text-muted'><b>Orario fine</b></span></Form.Label>
                              <Form.Control
                                type="time"
                                value={newExam?.ora_fine || ''}
                                onChange={(e) => setNewExam({ ...newExam, ora_fine: e.target.value })}
                              />
                            </Form.Group>
                          </Col>
                        </Row>

                        {/* --- SEZIONE TIPOLOGIA ESAME --- */}
                        <Form.Group className="mb-3">
                          <Form.Label><b>Tipologia Sessione</b></Form.Label>
                          <div className="d-flex gap-3">
                            <Form.Check
                              type="radio"
                              label="Esame Singolo"
                              name="creationType"
                              id="typeSingle"
                              checked={creationType === 'single'}
                              onChange={() => setCreationType('single')}
                            />
                            <Form.Check
                              type="radio"
                              label="Esame di Gruppo"
                              name="creationType"
                              id="typeMultiple" // Nota: mantengo l'ID typeMultiple per coerenza con lo stato, ma la logica è 'Gruppo'
                              checked={creationType === 'multiple'}
                              onChange={() => setCreationType('multiple')}
                            />
                          </div>
                        </Form.Group>

                        {creationType === 'multiple' && (
                          <Form.Group className="mb-3">
                            <Form.Label><b>Numero Posti Disponibili</b> <small className="text-muted">(Max 30)</small></Form.Label>
                            <Form.Control
                              type="number"
                              min="2"
                              max="30"
                              value={numeroPosti} // Usiamo la variabile 'numeroSlot' come 'numeroPosti'
                              onChange={(e) => setNumeroPosti(Math.min(30, Math.max(2, parseInt(e.target.value) || 2)))}
                            />
                            <Form.Text className="text-muted">
                              Verranno creati <b>{numeroPosti}</b> slot identici nello stesso orario ({newExam.ora_inizio} - {newExam.ora_fine}) per permettere a più corsisti di prenotarsi contemporaneamente.
                            </Form.Text>
                          </Form.Group>
                        )}
                        {/* ----------------------------------- */}
                      </Form>
                    );

      case MODAL_TYPES.EDIT: // Gestione separata per EDIT (non ha senso multiplo in edit)
            return (
              <Form>
                <Row>
                  <Col xs={6}>
                    <Form.Group>
                      <Form.Label><span className='text-muted'><b>Orario inizio</b></span></Form.Label>
                      <Form.Control type="time" value={newExam?.ora_inizio || ''} onChange={(e) => setNewExam({ ...newExam, ora_inizio: e.target.value })} />
                    </Form.Group>
                  </Col>
                  <Col xs={6}>
                    <Form.Group>
                      <Form.Label><span className='text-muted'><b>Orario fine</b></span></Form.Label>
                      <Form.Control type="time" value={newExam?.ora_fine || ''} onChange={(e) => setNewExam({ ...newExam, ora_fine: e.target.value })} />
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            );

    case MODAL_TYPES.VIEW:
            const corsista = newExam?.resource;
            const esito = newExam?.esito_esame;
            const haPassatoEsame = esito === 'promosso';
            const idAttestato = newExam?.id_attestato;
            const idClasseUtente = newExam?.id_classe_utente;

            // Handler interni (definiti qui per usare le variabili locali corsista, etc.)
            const handleDownloadAttestato = async () => {
                if (!idClasseUtente) { alertService.error("ID Classe Utente mancante."); return; }
                const filename = `attestato_${corsista.cognome}_${corsista.nome}.pdf`;
                await downloadAttestato({ id_classe_utente: idClasseUtente }, filename);
            };
            const handlePrepareStampaBusta = () => {
                if (!idAttestato) { alertService.error("ID Attestato mancante."); return; }
                const userDataForEnvelope = {
                    id_attestato: idAttestato,
                    id_agenzia: corsista.id_agenzia,
                    soggetto_spedizione: newExam.soggetto_spedizione || 'corsista'
                };
                openSelectRecipientModal(userDataForEnvelope); // Usa la funzione definita fuori
            };
            // Handler per Modifica Anagrafica (CHIAMA openEditUserModal)
            const handleEditProfile = () => {
                if (corsista) {
                    openEditUserModal(corsista); // Chiama la funzione per aprire la modale
                }
            };

            if (!corsista) {
                return (
                    <div>
                        <p><i className="bi bi-calendar-event me-2 text-muted"></i>Data: {formatDate(newExam?.data)}</p>
                        <p><i className="bi bi-clock me-2 text-muted"></i>Orario: {newExam?.ora_inizio?.slice(0, 5)} - {newExam?.ora_fine?.slice(0, 5)}</p>
                        <p className="text-muted fst-italic">Nessun corsista prenotato.</p>
                        <hr />
                        <h6 className="mb-3">Gestione Slot Esame:</h6>
                        <div className="d-grid gap-2 d-sm-flex">
                            <Button variant="outline-info" size="sm" onClick={handleEditClick}><i className="bi bi-pencil me-1"></i> Modifica Orario</Button>
                            <Button variant="outline-danger" size="sm" onClick={handleDeleteClick}><i className="bi bi-trash me-1"></i> Elimina Slot</Button>
                            {classe?.corso?.modalita_erogazione !== TIPO_CORSO.TELEMATICA_ASINCRONA && (
                                  <Button variant="outline-primary" size="sm" onClick={() => handleManageUsers(newExam)}><i className="bi bi-people me-1"></i> Gestisci Abilitati</Button>
                            )}
                        </div>
                    </div>
                );
            }

            // Se corsista esiste, mostra layout completo
            return (
              <div>
                {/* INTESTAZIONE */}
                <h5 className="mb-1">Corsista: <strong>{corsista.nome} {corsista.cognome}</strong></h5>
                <p className="mb-3">Esito: <span className={esito === 'promosso' ? 'text-success fw-bold' : (esito === 'bocciato' ? 'text-danger fw-bold' : '')}>{esito ? esito.replace('_', ' ') : 'Non registrato'}</span></p>
                {newExam?.stato_pagamento === 'Pagato' && (
                    <p className="mb-3 fst-italic small"> {/* Margine sotto per separare */}
                        <i className="bi bi-wallet2 me-1 text-muted"></i>
                        Pagato da: <span className={!newExam.pagamento_partner ? 'text-danger fw-bold' : 'text-muted'}>
                                    {getFontePagamentoText(newExam.pagamento_partner)}
                                  </span>
                    </p>
                )}
                <p>Data: {formatDate(newExam.data)} | Orario: {newExam?.ora_inizio?.slice(0, 5)} - {newExam?.ora_fine?.slice(0, 5)}</p>
                <hr className="my-4"/>
                {/* LAYOUT A QUADRANTI */}
                <div className="row g-3">
                  {/* Gestisci Risultati */}
                  <div className="col-md-6"> <div className="card h-100 shadow-sm"> <div className="card-body d-flex flex-column align-items-center justify-content-center text-center"> <i className="bi bi-clipboard-check fs-1 mb-2 text-success"></i> <h6 className="card-title">Risultati Esame</h6> <Button variant="outline-success" size="sm" onClick={() => navigate("/gestione-risultati-esame", { state: { examData: newExam, classeData: classe } })} className="mt-2"> <i className="bi bi-arrow-right-circle me-1"></i> Gestisci </Button> </div> </div> </div>
                  {/* Modifica Anagrafica */}
                  <div className="col-md-6"> <div className="card h-100 shadow-sm"> <div className="card-body d-flex flex-column align-items-center justify-content-center text-center"> <i className="bi bi-person-gear fs-1 mb-2 text-primary"></i> <h6 className="card-title">Anagrafica Corsista</h6> <Button variant="outline-primary" size="sm" onClick={handleEditProfile} disabled={!corsista?.id_utente} className="mt-2"> <i className="bi bi-pencil-square me-1"></i> Modifica </Button> </div> </div> </div>
                  {/* Stampa Attestato (Condizionale) */}
                  {haPassatoEsame && ( <div className="col-md-6"> <div className="card h-100 shadow-sm"> <div className="card-body d-flex flex-column align-items-center justify-content-center text-center"> <i className="bi bi-file-earmark-arrow-down fs-1 mb-2 text-success"></i> <h6 className="card-title">Attestato</h6> <Button variant="outline-success" size="sm" onClick={handleDownloadAttestato} disabled={!idClasseUtente || loadingStateAttestati.isLoadingDownloadAttestato} className="mt-2"> {loadingStateAttestati.isLoadingDownloadAttestato ? <Spinner size="sm" className="me-1"/> : <i className="bi bi-printer me-1"></i>} Stampa </Button> </div> </div> </div> )}
                  {/* Stampa Busta (Condizionale) */}
                  {haPassatoEsame && ( <div className="col-md-6"> <div className="card h-100 shadow-sm"> <div className="card-body d-flex flex-column align-items-center justify-content-center text-center"> <i className="bi bi-envelope-paper fs-1 mb-2 secondary"></i> <h6 className="card-title">Busta Spedizione</h6> <Button variant="outline-secondary" size="sm" onClick={handlePrepareStampaBusta} disabled={!idAttestato} className="mt-2"> <i className="bi bi-printer me-1 text-dark"></i> <font className="text-dark">Stampa</font> </Button> </div> </div> </div> )}
                  {/* Modifica Orario */}
                  <div className="col-md-6"> <div className="card h-100 shadow-sm"> <div className="card-body d-flex flex-column align-items-center justify-content-center text-center"> <i className="bi bi-clock-history fs-1 mb-2 text-info"></i> <h6 className="card-title">Modifica Orario Slot</h6> <Button variant="outline-info" size="sm" onClick={handleEditClick} className="mt-2"> <i className="bi bi-pencil me-1"></i> Modifica </Button> </div> </div> </div>
                  {/* Elimina Esame */}
                  <div className="col-md-6"> <div className="card h-100 shadow-sm"> <div className="card-body d-flex flex-column align-items-center justify-content-center text-center"> <i className="bi bi-trash fs-1 mb-2 text-danger"></i> <h6 className="card-title">Elimina Slot Esame</h6> <Button variant="outline-danger" size="sm" onClick={handleDeleteClick} className="mt-2"> <i className="bi bi-x-circle me-1"></i> Elimina </Button> </div> </div> </div>
                  {/* Gestisci Corsisti (Condizionale) */}
                  {classe?.corso?.modalita_erogazione !== TIPO_CORSO.TELEMATICA_ASINCRONA && ( <div className="col-md-6"> <div className="card h-100 shadow-sm"> <div className="card-body d-flex flex-column align-items-center justify-content-center text-center"> <i className="bi bi-people fs-1 mb-2 text-primary"></i> <h6 className="card-title">Gestisci Abilitati</h6> <Button variant="outline-primary" size="sm" onClick={() => handleManageUsers(newExam)} className="mt-2"> <i className="bi bi-pencil-square me-1"></i> Gestisci </Button> </div> </div> </div> )}
                {classe?.corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA && corsista && (
                    <div className="col-md-6">
                      <div className="card h-100 shadow-sm border-warning"> {/* Bordo per evidenziare */}
                        <div className="card-body d-flex flex-column align-items-center justify-content-center text-center">
                          <i className="bi bi-calendar-x fs-1 mb-2 text-warning"></i>
                          <h6 className="card-title">Annulla Prenotazione</h6>
                          <Button
                              variant="outline-warning" // Pulsante arancione
                              size="sm"
                              // Apre la modale di conferma
                              onClick={() => setShowConfirmDeleteModal(true)}
                              className="mt-2"
                          >
                              <i className="bi bi-exclamation-triangle me-1"></i>
                              Annulla
                          </Button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
      case MODAL_TYPES.MANAGE_USERS: // Logica originale per GESTIONE UTENTI
        const userPrenotato = newExam.utenti?.find(u => u.prenotato);
        return (
          <>
            {
              classe?.corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA ? (
                // Logica visualizzazione ASINCRONO
                <div>
                  {userPrenotato ? (
                    <div className="d-flex flex-column align-items-start">
                      <h5>Corsista prenotato: {userPrenotato.nome} {userPrenotato.cognome} ({userPrenotato.luogo_nascita}, {moment(userPrenotato.data_nascita).format('DD/MM/YYYY')})</h5>
                    </div>
                  ) : (
                    <h5>Nessun corsista prenotato</h5>
                  )}
                </div>
              ) : (
                // Logica visualizzazione SINCRONO (checkbox)
                <div>
                  <h5>Abilita corsisti alla prenotazione per l'esame del {moment(newExam.data).format('DD/MM/YYYY')}</h5>
                  {corsoUtenti.map(user => {
                    const isPrenotato = newExam.utenti?.some(u => u.id_utente === user.id_utente && u.prenotato);
                    return (
                      <div key={user.id_utente} className="d-flex justify-content-between align-items-center mb-2">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`user-${user.id_utente}`}
                            checked={isPrenotato || selectedExamUsers.some(u => u.id_utente === user.id_utente)}
                            onChange={() => !isPrenotato && handleUserSelection(user)}
                            disabled={isPrenotato}
                          />
                          <label className="form-check-label" htmlFor={`user-${user.id_utente}`} style={{ opacity: 1, color: 'inherit' }}>
                            {user.nome} {user.cognome} ({user.luogo_nascita}, {moment(user.data_nascita).format('DD/MM/YYYY')})
                            {isPrenotato && <span className="badge bg-success ms-2">Prenotato</span>}
                          </label>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )
            }
          </>
        );

      case MODAL_TYPES.DELETE:
        return (
          <div>
            <p className="fs-5">Sei sicuro di voler eliminare questo esame?</p>
            <p className="text-muted small">L'operazione è irreversibile.</p>
          </div>
        );

      default:
        return null;
    }
  };

  const getBackPath = () => {
    if (classe?.corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA) {
      return "/gestione-corsi"
    } else {
      return "/gestione-classi"
    }
  }

  if (!classe) {
    return <div>Caricamento...</div>;
  }

  return (
    <div className={`card custom-card w-100 shadow ${isWideScreen ? "p-5" : "px-1 py-3"}`} style={{ minHeight: "700px" }}>
      <div className="container">
        <ComebackArrow path={getBackPath()} />
        <div className="d-flex justify-content-between custom-card-header mb-3">
          <div className="d-flex gap-3 custom-card-title my-2">
            <div className={`custom-icon-container`}>
              {classe?.corso?.immagine_corso ? 
                <img src={classe?.corso?.immagine_corso} className='custom-icon' alt='immagine corso'/> : 
                <i className={`bi custom-icon bi-calendar-event fs-2`}></i>}
            </div>
            <div className="align-self-center">
              <span className="fs-4 d-block">
                <i>
                  <b>
                    <h2>{classe?.corso?.denominazione} - Esami</h2>
                  </b>
                </i>
              </span>
            </div>
          </div>
        </div>
        <div style={{ height: '100vh' }}>
        <CustomCalendar
          events={exams.map(exam => {
            const corsistiPrenotati = exam.utenti?.filter(u => u.prenotato) || [];
            const numeroPrenotati = corsistiPrenotati.length;
            
            // Fallback: se max_parts non è definito, è 1
            const maxParts = (exam.max_parts && exam.max_parts > 0) ? exam.max_parts : 1; 
            const countdownText = examCountdowns[exam.id_calendario_esame];
            
            // --- 1. GESTIONE TITOLI (ROBUSTA) ---
            let headerText = null; 
            
            // Determiniamo se è un gruppo controllando SIA il flag CHE i posti
            const isGruppo = (exam.is_multiplo == 1) || (maxParts > 1);


            if (isGruppo) {
               // Priorità assoluta: se è un gruppo, mostra sempre il titolo
               headerText = `Esame di gruppo (${numeroPrenotati}/${maxParts})`;
            } else if (classe?.corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_SINCRONA) {
               // Se è sincrono (e non gruppo esplicito), mostra titolo sincrono
               headerText = `Esame Sincrono`; 
            }
            // Altrimenti (Esame Singolo asincrono) -> headerText rimane null (nessun titolo)
            // ------------------------------------

            let eventContent = null;

            if (numeroPrenotati === 0) {
              // --- CASO 1: SLOT VUOTO (Disponibile) ---
              eventContent = (
                <div className="d-flex flex-column h-100 justify-content-start">
                  {/* Titolo presente solo se Gruppo o Sincrono */}
                  {headerText && <div style={{fontSize: '0.85rem', fontWeight: 'bold', marginBottom: '2px'}}>{headerText}</div>}
                  
                  {/* Scritta Disponibile */}
                  <div style={{ color: '#54b954ff', fontWeight: 'bold', marginTop: 'auto' }}> 
                    <i className="bi bi-check-circle me-1"></i>
                    Disponibile
                  </div>
                </div>
              );
            } else {
              // --- CASO 2: CI SONO PRENOTATI ---
              
              const listaNomi = corsistiPrenotati.map(user => {
                let statusBadge = null;
                // Gestione stati
                if (user.presenza === 'assente') {
                    statusBadge = <span className="badge bg-danger ms-1" style={{fontSize: '0.7em'}}>Assente</span>;
                } else if (user.esito_esame === 'promosso') {
                    statusBadge = <span className="badge bg-success ms-1" style={{fontSize: '0.7em'}}>Promosso</span>;
                } else if (user.esito_esame === 'bocciato') {
                    statusBadge = <span className="badge bg-warning text-dark ms-1" style={{fontSize: '0.7em'}}>Bocciato</span>;
                }

                return (
                  <div key={user.id_utente} style={{ fontSize: '0.85rem', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    <i className="bi bi-person-fill me-1"></i>
                    {user.cognome} {user.nome}
                    {statusBadge}
                  </div>
                );
              });

              // Verifica se tutti hanno terminato
              const tuttiFiniti = corsistiPrenotati.every(u => 
                  u.esito_esame === 'promosso' || 
                  u.esito_esame === 'bocciato' || 
                  u.presenza === 'assente'
              );

              const hasNotStarted = countdownText && countdownText !== 'INIZIATO';
              let actionElement = null;

              if (countdownText === 'INIZIATO') {
                if (!tuttiFiniti) {
                    actionElement = (
                      <Button
                        variant="light" 
                        size="sm"
                        className="mt-2 text-success fw-bold w-100"
                        onClick={(e) => {
                          e.stopPropagation();
                          enterJoinRoom(exam.id_calendario_esame, exam);
                        }}
                      >
                        <i className="bi bi-camera-video-fill me-2"></i>
                        Accedi
                      </Button>
                    );
                }
              } else if (hasNotStarted) {
                actionElement = <div className="mt-1 badge bg-light text-dark">{countdownText}</div>;
              }

              eventContent = (
                <div className="d-flex flex-column h-100">
                  {/* Titolo presente solo se Gruppo o Sincrono */}
                  {headerText && (
                    <div className="border-bottom pb-1 mb-1" style={{fontSize: '0.9rem'}}>
                        <strong>{headerText}</strong>
                    </div>
                  )}
                  
                  <div className="flex-grow-1" style={{ overflowY: 'auto', minHeight: '20px' }}>
                    {listaNomi}
                  </div>

                  <div className="mt-auto pt-2">
                    {actionElement}
                  </div>
                </div>
              );
            }

            return {
              id_calendario_esame: exam.id_calendario_esame,
              ...exam, 
              title: eventContent, 
              start: new Date(`${exam?.data}T${exam?.ora_inizio}`),
              end: new Date(`${exam?.data}T${exam?.ora_fine}`),
              allDay: false,
              // Verde se c'è almeno un prenotato, Rosso se vuoto
              color: numeroPrenotati > 0 ? '#198754' : '#dc3545' 
            };
          })}
          availableViews={["month", "agenda"]}
          onSelectSlot={handleSelectSlot}
          onSelectEvent={handleSelectEvent}
          minDate={minDate}
          isLoading={loadingStateEsami.getEsamiByIdClasse}
        />

          {/* <CustomCalendar
            events={exams.map(exam => {
              //var stringaCorsistiPrenotati = "";
              const corsistiPrenotati = exam.utenti?.filter(u => u.prenotato)?.length || 0;
              //console.log(exam.utenti.cognome);
              const corsistiAbilitati = exam.utenti?.length || 0;
              const isSincronoTitle = classe?.corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_SINCRONA 
                ? `Esame (${corsistiPrenotati}/${corsistiAbilitati} prenotati)` 
                : corsistiPrenotati > 0 
                  ? `${exam.utenti?.find(u => u.prenotato === 1)?.cognome || ''} ${exam.utenti?.find(u => u.prenotato === 1)?.nome || ''}` 
                  : `Non prenotato`;
              return {
                id_calendario_esame: exam.id_calendario_esame,
                title: isSincronoTitle,
                start: new Date(`${exam?.data}T${exam?.ora_inizio}`),
                end: new Date(`${exam?.data}T${exam?.ora_fine}`),
                allDay: false,
                color: corsistiPrenotati > 0 ? 'green' : 'red'
              };
            })}
            availableViews={["month", "agenda"]}
            //views={["month", "agenda"]}
            onSelectSlot={handleSelectSlot}
            onSelectEvent={handleSelectEvent}
            minDate={minDate}
            isLoading={loadingStateEsami.getEsamiByIdClasse}
          /> */}
        </div>
        <CustomModal
          show={showModal}
          onHide={handleCloseModal}
          headerText={<h5 className="form-control-static">{formatDate(newExam.data)}</h5>}
          size={modalMode === MODAL_TYPES.DELETE || modalMode === MODAL_TYPES.EDIT || modalMode === MODAL_TYPES.MANAGE_USERS || modalMode === MODAL_TYPES.NEW ? "md" : "lg"}
          
          // 1. CORREZIONE TESTO PULSANTE
          btnText={
            modalMode === MODAL_TYPES.DELETE
              ? "Elimina Esame" // Testo specifico per la cancellazione
              : (modalMode === MODAL_TYPES.MANAGE_USERS && classe?.corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA && userPrenotato)
                ? "Annulla Prenotazione"
                : "Salva modifiche"
          }

          // 2. AGGIUNTA VARIANTE COLORE (Opzionale ma consigliato)
          variant={modalMode === MODAL_TYPES.DELETE ? "danger" : "primary"}

          body={renderModalBody()}
          btnCancelText={'Chiudi'}
          closeButton={true}
          
          // Aggiungi isLoadingEsameDelete al loading state
          isLoading={loadingStateEsami.isLoadingEsameCreating || loadingStateEsami.isLoadingEsameUpdate || loadingStateEsamiUtenti.isLoadingEsameUtenteCreating || loadingStateEsamiUtenti.isLoadingEsameUtenteUpdate || loadingStateEsami.isLoadingEsameDelete}
          
          onUndoChanges={handleCloseModal}
          
          // 3. CORREZIONE AZIONE DI SALVATAGGIO
          onSave={
            modalMode === MODAL_TYPES.DELETE
              ? handleDeleteExam // <-- Collega la funzione di cancellazione qui!
              : (modalMode === MODAL_TYPES.MANAGE_USERS && classe?.corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA && userPrenotato)
                ? () => setShowConfirmDeleteModal(true)
                : (modalMode === MODAL_TYPES.NEW || modalMode === MODAL_TYPES.EDIT)
                  ? handleSaveExam
                  : modalMode === MODAL_TYPES.MANAGE_USERS
                    ? handleSaveUserSelection
                    : null
          }

          hideSaveBtn={
            modalMode === MODAL_TYPES.MANAGE_USERS &&
            classe?.corso?.modalita_erogazione === TIPO_CORSO.TELEMATICA_ASINCRONA &&
            !userPrenotato
          }

          // 4. CORREZIONE VISIBILITÀ PULSANTI
          // Aggiungi && modalMode !== MODAL_TYPES.DELETE per NON nascondere i pulsanti in cancellazione
          hideButtons={
            modalMode !== MODAL_TYPES.NEW && 
            modalMode !== MODAL_TYPES.EDIT && 
            modalMode !== MODAL_TYPES.MANAGE_USERS && 
            modalMode !== MODAL_TYPES.DELETE 
          }
        />
        <CustomModal
          show={showConfirmDeleteModal}
          onHide={() => setShowConfirmDeleteModal(false)}
          headerText={<h5 className="form-control-static">Conferma Annullamento</h5>}
          size="md"
          body={
            <p>Sei sicuro di voler annullare la prenotazione di <b>{userPrenotato?.nome} {userPrenotato?.cognome}</b>?</p>
          }
          btnText={"Conferma Annullamento"}
          btnCancelText={"Chiudi"}
          onUndoChanges={() => setShowConfirmDeleteModal(false)}
          onSave={handleConfirmCancelUserBooking}
          isLoading={loadingStateEsamiUtenti?.isLoadingEsameUtenteDelete}
        />
        {/* Modale Selezione Destinatario Busta */}
         <CustomModal
            show={modalStateAttestati.showSelectRecipientModal}
            onHide={handleCloseSelectRecipientModal}
            headerText="Stampa Busta - Seleziona Destinatario"
            size={"sm"}
            btnText={"Salva e Stampa"}
            body={
                <SelectRecipientModal
                    show={modalStateAttestati.showSelectRecipientModal}
                    attestatoData={userForEnvelopePrint}
                    onSubjectChange={handleSubjectChangeForPrint}
                    currentSoggetto={selectedSoggettoForPrint}
                />
            }
            isLoading={loadingStateAttestati.isLoadingUpdateSpedizione || loadingStateAttestati.isPrintingEnvelope}
            onUndoChanges={handleCloseSelectRecipientModal}
            onSave={handleConfirmRecipientAndPrint}
            disableSave={selectedSoggettoForPrint === 'agenzia' && !userForEnvelopePrint?.id_agenzia}
        />
        <CustomModal
            show={modalStateUtenti.showModalUpdateUtente} // Controllata dallo stato di useUtenti
            onHide={handleCloseEditUserModal} // Funzione per chiudere
            headerText={`Aggiorna informazioni - ${selectedUtenteForEdit?.nome || ''} ${selectedUtenteForEdit?.cognome || ''}`}
            size={"lg"}
            hideSaveBtn={true} // Nasconde pulsanti CustomModal
            footerStyle={"d-none"} // Nasconde footer CustomModal
            body={
                selectedUtenteForEdit ? (
                    <InputUserinfo
                        userData={selectedUtenteForEdit} // Passa dati utente
                        isUpdateUserFromModal={true}
                        onHide={handleCloseEditUserModal} // Funzione per chiudere da dentro InputUserinfo
                        // Passa una funzione per aggiornare i dati dopo il salvataggio, se necessario
                        // printAllUtenti={fetchExams} // Adatta questa funzione se serve ricaricare gli esami
                    />
                ) : <p>Caricamento dati utente...</p> // Fallback
            }
            closeButton={true} // Mostra X
            onUndoChanges={handleCloseEditUserModal} // Associa X alla chiusura
        />
      </div>
    </div>
  );
}
